// src/constants.ts
import { ROUTES } from '@/routes';

export const NAVIGATE_MAPPING_ALARM: Record<string, { goal: string }> = {
  '택배 발송이 곧 마감돼요': {
    goal: `${ROUTES.orderDetails}?orderTab=ready-to-ship`,
  },

  '판매몰 신규 리뷰': {
    goal: `${ROUTES.reviews}?ctab=whole`,
  },
  '상품 순위 모니터링': {
    goal: ROUTES.monitoring,
  },

  '뉴스 브리핑': {
    goal: ROUTES.dashboard,
  },
  '판매 돌파!': {
    goal: ROUTES.statistics,
  },
  '판매몰 신규 알림': {
    goal: `${ROUTES.orderDetails}?orderTab=new-order`,
  },
  '문의사항 답변드려요': {
    goal: `${ROUTES.more}?ctab=support&chistory=true`,
  },
  '마켓 연동 안내': {
    goal: ROUTES.market,
  },
  '일일 보고드려요': {
    goal: ROUTES.statistics,
  },
  '문의 처리 지연': {
    goal: `${ROUTES.inquiries}?ctab=not-yet`,
  },
  '지난달 보고드려요': {
    goal: ROUTES.statistics,
  },
};
